<div fxLayout="row" fxLayoutAlign="center end">
    <app-dice [name]="'PoW'" [imagesList]="imagesDicePOW" [value]="dicePOWValue" [diceWidth]="diceWidth"></app-dice>
    <app-dice [name]="'PoS'" [imagesList]="imagesDicePOS" [value]="dicePOSValue" [diceWidth]="diceWidth"></app-dice>
</div>
